// Strings owned by the optimal-slots widget.

export const OPTIMAL_SLOTS_STRINGS = {
  title: "Best times to post",
  subtitle: "Top admin-post slots by engagement (last 28 days)",
  noteRelativeAndSample:
    "Scores are relative to your most engaging slot — never an absolute confidence percent. The sample size is shown alongside so you can judge reliability yourself.",
  /** Insufficient-branch headline. */
  empty: {
    title: "Need more data",
    body: "Post regularly for 4 weeks to unlock time-slot recommendations.",
  },
  shortfall: {
    /** "{n} more days of data" — populated days_remaining hint. */
    days: (days: number): string =>
      days === 1 ? "1 more day of data" : `${days} more days of data`,
    /** "{n} more admin posts" — populated posts_remaining hint. */
    posts: (posts: number): string =>
      posts === 1 ? "1 more admin post" : `${posts} more admin posts`,
    /** "{n} slots short of the 3-sample floor" — slots_short hint. */
    slots: (slots: number): string =>
      slots === 1
        ? "1 slot short of the 3-sample floor"
        : `${slots} slots short of the 3-sample floor`,
    /** "{n} admin posts so far" — totalAdminPosts. */
    so_far: (posts: number): string =>
      posts === 1
        ? "1 admin post so far"
        : `${posts} admin posts so far`,
  },
  /** "Score" / "Sample size" column hints. */
  scoreLabel: "Relative score",
  sampleLabel: "Sample size",
} as const;

export type OptimalSlotsStrings = typeof OPTIMAL_SLOTS_STRINGS;
